import { BiImage, BiVideo } from 'react-icons/bi';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { MediaType } from 'src/enums/surfer.enums';

export const mediaTypeConf = (mediaType: MediaType) => {
  switch (mediaType) {
    case MediaType.Video:
      return {
        border: 'rgba(108, 40, 217, 0.6)',
        pill: {
          color: '#6d28d9',
          background: '#f5f3ff',
          borderColor: '#ddd6fe',
        },
        icon: BiVideo,
      };
    case MediaType.Image:
      return {
        border: 'rgba(4, 120, 87, 0.6)',
        pill: {
          color: '#047857',
          background: '#ecfdf5',
          borderColor: '#a7f3d0',
        },
        icon: BiImage,
      };

    case MediaType.Document:
      return {
        border: 'rgba(194, 65, 12, 0.6)',
        pill: {
          color: '#c2410c',
          background: '#fff7ed',
          borderColor: '#fed7aa',
        },
        icon: HiOutlineDocumentText,
      };

    default:
      return {
        border: 'rgba(194, 65, 12, 0.6)',
        pill: {
          color: '#c2410c',
          background: '#fff7ed',
          borderColor: '#fed7aa',
        },
        icon: HiOutlineDocumentText,
      };
  }
};
